export interface FetchInstitutionByIDResponse {
  message: string;
  data: FetchInstitutionByIDData;
}

export interface FetchInstitutionByIDData {
  name: string;
  phone_number: string | number | null;
  address: string | null;
}
